
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
  }
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    modalContainer: {
      "& .MuiDialog-paperWidthMd": {
        maxWidth: "56.25rem!important",
        overflow:"hidden!important",
        "& >div":{
          overflow:"auto!important"
        }
      },
      "& header":{
        marginBottom:"0!important"
      }
    },
    orderDetailsModalContainer: {
      "& .MuiDialog-paperWidthMd": {
        "@media only screen and (min-width: 768px)": {
          width: "6.9375rem !important",
          minWidth: "6.9375rem!important;"
        },
      },
     
    },
    columnsHeader:{
      alignItems: "center",
      width:"100%",
      paddingRight:"11.5625rem",
      paddingLeft:"4.375rem",
      display: "grid",
      marginBottom:"1.25rem",
      gridTemplateColumns:"40% 40% 20%",
      "@media only screen and (max-width: 768px)": {
        display:"none!important"
      },
      "& >div":{
        "& >span":{
          ...setItemFontStyles("Open Sans","normal","normal","0.9rem","1.25rem","#8D98B7"),
          display: "flex",
          justifyContent:"start",
          alignItems: "center",
        }
      }
    },
    listWrapper:{
      paddingRight:"7.1875rem",
      "& >div>div>div>div>div":{
        "& >span":{
          color: "#212121",
        },
        "& >span:first-child":{
          ...setItemFontStyles("Open Sans","normal",600,"1rem","1.375rem","#212121"),
          display:"flex",
          justifyContent:"start"
        }
      },
      "@media only screen and (max-width: 768px)": {
        paddingRight:"0!important",
    },
    },
    aplliedFilters:{
      background: "#FFFCE6",
      border: "1px solid #FFDD02",
      boxSizing: "border-box",
      borderRadius: "8px",
      "& >svg":{
        "& >path":{
          fill:"#FFDD02!important",
        } 
      }
    },
    filterBtn:{
      background: "#E8EAF4",
      borderRadius: "0.5rem",
      fontSize: "1rem",
      lineHeight: "1.375rem",
      padding: "0.75rem 1.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      "& >svg":{
       marginRight:" 0.625rem",
       fill: "#C1CAE1",
       width: "0.875rem",
       height: "0.875rem",
       "& >path":{
        fill: "#C1CAE1",
       }
      },
      "& >p":{
        ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#616161"),
        display: "flex",
        alignItems: "center",
       "& >span":{
        marginLeft: "0.5rem",
       }
      }
      
    },
    customerItem:{
      padding:"1.5rem 4rem",
      marginRight:".375rem",
      backgroundColor: "#FFFFFF",
      borderRadius: "0.75rem",
      cursor: "pointer",
      "& >div":{
        display: "grid",
        gridTemplateColumns:"40% 40% 20%",
        "@media only screen and (max-width: 768px)": {
          gridTemplateColumns:"50% 50%!important",
        },
        "& >span":{
          ...setItemFontStyles("Open Sans","normal","normal","0.9375rem","1.625rem","#616161"),
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          paddingLeft:8
        },
        "& >span:last-child":{
          "& >div":{
            "@media only screen and (max-width: 768px)": {
              marginLeft:"0!important",
            }
          }
        }
      }
    },
    controlers:{
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      margin:"0 3.125rem 2.5rem",
      "& .search":{
        minWidth:"23.75rem",
        "@media only screen and (max-width: 768px)": {
            minWidth:"15.75rem!important",
        },
      },
     
    },
    loadingWrapper:{
      margin:"10rem",
      display:"flex",
      alignItems:"center",
      justifyContent:"center"
    },
    OrderHistoryPageDialog: {
      "@media only screen and (min-width: 768px)": {
        
          width: "43.75rem !important",
          minWidth: "43.75rem !important",
          marginRight: "auto",
          marginLeft: "auto",
          hight: '10rem'
      }
    },
    formScroll: {
      overflow: "scroll",
    }
  }),
);